export default "__VITE_ASSET__Cr9YalWl__"